import { render, staticRenderFns } from "./BannerAlarma.vue?vue&type=template&id=d311eb5c&scoped=true"
import script from "./BannerAlarma.vue?vue&type=script&lang=js"
export * from "./BannerAlarma.vue?vue&type=script&lang=js"
import style0 from "./BannerAlarma.vue?vue&type=style&index=0&id=d311eb5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d311eb5c",
  null
  
)

export default component.exports